import { useTranslation } from "react-i18next";
import { Container, PaletteMode, Typography } from "@mui/material";

import { HtmlViewer } from "../components";
import { TC_URL_HEIGHT } from "../config";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectPropertiesApp, selectTheme } from "../redux";

const keyPrefix = "pages.TCPage";

export const TCPage = () => {
  const [mode, setMode] = useState<PaletteMode>("light");
  const { theme } = useSelector(selectTheme);
  const properties = useSelector(selectPropertiesApp);
  const uri = properties["url.tyc"] || "";
  const { t } = useTranslation("translation", { keyPrefix });

  const getUri = (colorScheme: PaletteMode) => {
    console.log("URI:", uri.split(".html"));
    let newUri = uri.replace(/^http:/, "https:").split(".html")[0];
    if (theme === "default") {
      console.log("SE SELECCIONA EL TEMA POR DEFECTO", colorScheme);
      newUri += colorScheme === "dark" ? "_dark.html" : ".html";
    } else {
      console.log("SE SELECCIONA EL TEMA", theme);
      newUri += theme === "dark" ? "_dark.html" : ".html";
    }
    console.log("NEW URI:", newUri);
    return newUri;
  };

  const handleChange = (event: MediaQueryListEvent) => {
    if (theme === "default") setMode(event.matches ? "dark" : "light");
  };

  useEffect(() => {
    console.log("theme", theme);

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    if (theme !== "default") {
      setMode(theme);
    } else {
      setMode(mediaQuery.matches ? "dark" : "light");
    }

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [theme]);

  return (
    <Container maxWidth="lg" sx={{ height: TC_URL_HEIGHT }}>
      <Typography variant="h4" mt={2} ml={2}>
        {t("title")}
      </Typography>
      <HtmlViewer src={getUri(mode)} title={t("title")} />
    </Container>
  );
};
